export default __webpack_public_path__ + "static/size-292ef633d61dace3a98b634e8d716f93.png";